<template>
    <div class="audience">
        <div class="wrapper">
            <transition
                name="fade"
                tag="div"
                mode="out-in"
            >
                <Session
                    v-if="conversations.size && othersInRoom && yourUid !== 'unknown'"
                    :key="userConv"
                    :expoId="expoId"
                    :roomStr="roomStr"
                    :convId="userConv.split('=').slice(-1)[0]"
                />
            </transition>
            <div v-if="conversations.size && othersInRoom">
                <h1>Conversations</h1>
                <transition-group
                    name="fade-width"
                    tag="div"
                    class="users"
                >
                    <div
                        v-for="thisRoomConv in conversations"
                        :key="thisRoomConv"
                    >
                        <transition-group
                            name="fade-height"
                            tag="div"
                            class="conv"
                            @click.native="joinConv(thisRoomConv)"
                        >
                            <UserImg
                                :usr="$parent.getUser(uid)"
                                v-for="uid in usersInConv(thisRoomConv, includeYou=false)"
                                :key="uid /* TODO: Find a better soluion */"
                                :interactive="false"
                                :expoId="expoId"
                                size="60px"
                            />
                            <UserImg
                                :key="yourUid"
                                :class="{ 'you': true, 'in-conv': usersInConv(thisRoomConv).includes(yourUid) }"
                                :usr="$parent.getUser(yourUid)"
                                :interactive="false"
                                :expoId="expoId"
                                size="60px"
                            />
                            <MdAddIcon
                                v-if="usersInConv(thisRoomConv, includeYou=true).length == 0"
                                class="icon"
                                key="add"
                            />
                        </transition-group>
                    </div>
                </transition-group>
            </div>
            <div v-if="presentUsers.length">
                <h1>In This Room</h1>
                <div class="users">
                    <UserImg
                        :usr="$parent.getUser(uid)"
                        v-for="uid in presentUsers"
                        :key="uid /* TODO: Find a better soluion */"
                        :expoId="expoId"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MdAddIcon from 'vue-ionicons/dist/md-add.vue'

import UserImg from '../user/UserImg'
import Session from './video/Session'

import { auth } from '../../../db'

export default {
    name: 'Audience',
    props: ['expoId', 'roomStr', 'userConv', 'newConv'],
    components: {
        UserImg,
        Session,
        MdAddIcon
    },
    computed: {
        conversations() {
            var conversations = new Set()
            for (let uid of this.presentUsers) {
                let usr = this.$parent.presentUserMap[uid]
                conversations.add(usr.currentRoom)
            }
            if (conversations.has(this.newConv)) { // We're in newConv or someone else is
                if (this.usersInConv(this.newConv, false).length > 0) {
                    this.$parent.generateNewConv() // If someone else is in our newConv, generate a new newConv in case we want to join it
                }
                conversations.delete(this.newConv)
            } else { // newConv is not in the list of conversations (we're in another conversation)
            }
            conversations.add(this.newConv) // make sure newConv is last
            return conversations
        },
        yourUid() {
            if (this.$store.state.user.data) return this.$store.state.user.data.uid
            else if (!auth.currentUser) return 'unknown'
            else return auth.currentUser.uid
        },
        userInGroupConv() {
            return this.usersInConv(this.userConv).length > 1
        },
        othersInRoom() {
            for (let uid of this.presentUsers) {
                if (uid !== this.yourUid) {
                    return true
                }
            }
            return false
        },
        presentUsers() {
            let presentUsers = Object.keys(this.$parent.presentUserMap)
            let now = Date.now()
            return presentUsers.filter(usr => {
                let usrInfo = this.$parent.userMap[usr]
                return usrInfo && (usrInfo.demo || this.$parent.presentUserMap[usr].dt > now - 3600000)
            })
        },
    },
    methods: {
        joinConv(path) {
            if (this.$store.state.user.data) {
                this.$router.push('/expo/' + path)
            } else {
                this.$router.push({ name: 'Log In', params: { routeAfter: '/expo/' + path }})
            }
        },
        usersInConv(path, includeYou=true) {
            let conv_rooms = path.split('/')
            let conv_room = conv_rooms[conv_rooms.length - 1]
            var usersInConv = []
            for (let uid of this.presentUsers) {
                let usr = this.$parent.presentUserMap[uid]
                let rooms = usr.currentRoom.split('/')
                if (rooms.length > 0) {
                    let last_room = rooms[rooms.length - 1]
                    if (last_room == conv_room && (includeYou || uid !== this.yourUid)) {
                        usersInConv.push(uid)
                    }
                }
            }
            return usersInConv
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../../interface.scss';

.audience .wrapper {
    margin: 0 160px 0 160px;
    padding-top: 40px;
}
.users {
    display: flex;
    justify-content: center;
    flex-direction: row;
    .conv {
        margin: 10px;
        display: flex;
        flex-direction: column;
        height: fit-content;
        border-radius: 800px;
        cursor: pointer;
        box-shadow: 0 0 0 5px var(--main-color);
        transition: box-shadow 0.1s ease;
        max-width: 140px;
        min-height: 100px;
        position: relative;
        .you {
            max-height: 0;
            opacity: 0;
            transition: all 0.2s ease;
            transition-property: max-height opacity;
            pointer-events: none;
            &.in-conv {
                max-height: 140px;
                opacity: 1;
                pointer-events: inherit;
            }
        }
        .icon {
            position: absolute;
            transition: all 0.2s ease;
            transition-property: opacity;
            width: 60px;
            height: 60px;
            font-size: 60px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &:hover {
            box-shadow: 0 0 0 8px var(--main-color);
            ::v-deep .tooltip {
                opacity: 1 !important;
            }
            .you {
                max-height: 140px;
                opacity: 1;
                pointer-events: inherit;
            }
            .icon {
                opacity: 0;
            }
        }
    }
}

.fade-height-enter-active, .fade-height-leave-active, .fade-height-move {
    transition: all 0.2s ease;
    transition-property: opacity max-height transform;
}
.fade-height-enter, .fade-height-leave-to {
    opacity: 0;
    max-height: 0px;
}
.fade-height-enter-to, .fade-height-leave {
    opacity: 1;
    max-height: 140px;
}

.fade-width-enter-active, .fade-width-leave-active, .fade-width-move {
    transition: all 0.2s ease;
    transition-property: opacity max-width transform;
}
.fade-width-enter, .fade-width-leave-to {
    opacity: 0;
    max-width: 0px;
}
.fade-width-enter-to, .fade-width-leave {
    opacity: 1;
    max-width: 140px;
}
</style>